import { render } from "./ListField.vue?vue&type=template&id=2c87feea"
import script from "./ListField.vue?vue&type=script&lang=js"
export * from "./ListField.vue?vue&type=script&lang=js"

import "./ListField.vue?vue&type=style&index=0&id=2c87feea&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__